import {installScript} from "./scriptUtil";
import SessionStore from "../../../services/session/SessionStore";
import BrandConfigStore from "../../../services/config/BrandConfigStore";
import {markAsShown, upsertUserPreferences, userPreferences} from "../../../services/users/usersApi";
import * as mobx from 'mobx'

function rightUserType(ug) {
    let matchingUserType = ug.activeForUserType || ""
    matchingUserType = matchingUserType.replace(/\s/g, ''); //Remove white space
    return   "All User Roles" == ug.activeForUserType || SessionStore.user.userType == matchingUserType
}

function rightUser(ug) {
    return ug.activeForUsers.includes(SessionStore.user.userId)
}

function matchesUserAndUserType(ug) {
    if (ug.activeForUserType == "None") {
        return rightUser(ug)
    } else {
        return rightUserType(ug) || rightUser(ug)
    }
}

function alreadyShownToUser(ug, userPrefs) {
    const alreadySeenByUser = userPrefs.seenGuides || []
    const answer = ug.onlyShowOncePerUser && alreadySeenByUser.includes(ug.userguidingId)
    return answer
}

let guidesLoaded = false
function showProperUserGuide(userPrefs){
    const filteredGuides = BrandConfigStore.brandConfig.userguiding.filter(ug => ug.isActive && matchesUserAndUserType(ug) && ! alreadyShownToUser(ug,userPrefs))
    if(filteredGuides.length > 0 && !guidesLoaded) {
            guidesLoaded = true
            const guideToShow = filteredGuides[0];
            const userguidingId = guideToShow.userguidingId;
            const containerId = guideToShow.containerId;
            console.log("containerId " + containerId);
            (function (u, s, e, r, g) {
                u[r] = u[r] || [];
                u[r].push({
                    'ug.start': new Date().getTime(), event: 'embed.js',
                });
                var f = s.getElementsByTagName(e)[0],
                    j = s.createElement(e);
                j.async = true;
                j.src = 'https://static.userguiding.com/media/user-guiding-'
                    + g + '-embedded.js';
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'userGuidingLayer', containerId);

            // your userguiding custom attribute tracking function
            // this will be executed when userguiding script is loaded and client SDK is ready
            function userGuidingTrack() {
                if(guideToShow.isNPS){
                    userGuiding.finishPreview()
                    userGuiding.triggerNps({force:true})
                    window.userGuidingUserId='locationHQChatmeter'
                    console.log("userGuiding.triggerNps")
                }else{
                    userGuiding.previewGuide(userguidingId)
                    console.log("userGuiding.previewGuide",userguidingId)
                }

            }

            // window.userGuidingLayer is defined inside userguiding code snippet
            // you can push your onload callback to userGuidingLayer safely
            window.userGuidingLayer.push({
                event: 'onload',
                fn: userGuidingTrack,
            });

            markAsShown(userguidingId)
    }
}



function allInfoAvailable() {
    return !!(BrandConfigStore.brandConfig && BrandConfigStore.brandConfig.userguiding && SessionStore.user);
}

function showGuide(){
  const loadedUserPreferences = SessionStore.userPreferences;
  showProperUserGuide(loadedUserPreferences)
}
let disposer
export function initialize() {
    uninitialize()

    disposer = mobx.when(
        // when the account and user is initialized
        () => allInfoAvailable(),
        () => showGuide()
    )

}

export function uninitialize() {
    disposer && disposer()
}




